import React from 'react';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createSunrunPalette } from './palette';

const SunrunThemeContext = React.createContext<{isDarkMode: boolean, setDarkMode: React.Dispatch<any>}>({
  isDarkMode: false,
  setDarkMode: () => {}
});

const createSunrunMuiTheme = (isDarkMode: boolean, themeOverrides: any) => {
  const externalThemeOverrides = Array.isArray(themeOverrides) ? themeOverrides : [themeOverrides];
  return createTheme({
    palette: createSunrunPalette(isDarkMode),
    overrides: {}, // all overrides here
  }, ...externalThemeOverrides);
};

const SunrunThemeProvider = ({ children, themeOverrides }) => {
  const [isDarkMode, setDarkMode] = React.useState(() => {
    const persistedDarkMode = localStorage.getItem('sunrunMuiDarkMode');
    return persistedDarkMode === 'true' ? true : false;
  });
  const theme = createSunrunMuiTheme(isDarkMode, themeOverrides);

  return (
    <SunrunThemeContext.Provider value={{ isDarkMode, setDarkMode }}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline/>
        { children }
      </MuiThemeProvider>
    </SunrunThemeContext.Provider>
  );
}

const useSetDarkMode = () => {
  const { isDarkMode, setDarkMode } = React.useContext(SunrunThemeContext);
  localStorage.setItem('sunrunMuiDarkMode', isDarkMode.toString());
  return [isDarkMode, setDarkMode];
}

export {
  SunrunThemeProvider,
  createSunrunMuiTheme,
  useSetDarkMode,
}
